import Api from '@/services/api/api/index.js'
import endpoints from './endpoint'

const fetch = (args) => {
  let params = new URLSearchParams();
  params.append('course_code', args.course_code);
  params.append('calendar_id', args.calendar_id);
  return Api.get(endpoints.get('get')+'?'+params.toString());
}

const start = (args) => {
  let params = new URLSearchParams();

  params.append('course_code', args.course_code);
  params.append('calendar_id', args.calendar_id);
  params.append('exam', args.exam);

  return Api.post(endpoints.get('start'), params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Hollow-Man': localStorage.getItem('client_init_ts') ?? ''
    }
  });
}

const finish = (args) => {
  let params = new URLSearchParams();

  params.append('course_code', args.course_code);
  params.append('calendar_id', args.calendar_id);
  params.append('exam', args.exam);
  params.append('finish', args.calendar);

  return Api.post(endpoints.get('finish'), params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Hollow-Man': localStorage.getItem('client_init_ts') ?? ''
    }
  });
}


export default {
  fetch,
  start,
  finish
};
